import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useRef, useState, useEffect } from 'react';
import qs from 'qs';
import get from 'lodash.get';
import { useFormikContext } from 'formik';
import Select from './Select';
import SelectField from './SelectField';

var ResourceSelect = function ResourceSelect(_ref) {
  var name = _ref.name,
      method = _ref.method,
      delay = _ref.delay,
      _ref$debounceTimeout = _ref.debounceTimeout,
      debounceTimeout = _ref$debounceTimeout === void 0 ? delay : _ref$debounceTimeout,
      itemsPerPage = _ref.itemsPerPage,
      watchParams = _ref.watchParams,
      cacheUniq = _ref.cacheUniq,
      additional = _ref.additional,
      resource = _ref.resource,
      onPageChange = _ref.onPageChange,
      hasMore = _ref.hasMore,
      graphqlConfig = _ref.graphqlConfig,
      minCharsToSearch = _ref.minCharsToSearch,
      onFocus = _ref.onFocus,
      waitUntilFocused = _ref.waitUntilFocused,
      defaultToOnlyOption = _ref.defaultToOnlyOption,
      shouldSearch = _ref.shouldSearch,
      rest = _objectWithoutPropertiesLoose(_ref, ["name", "method", "delay", "debounceTimeout", "itemsPerPage", "watchParams", "cacheUniq", "additional", "resource", "onPageChange", "hasMore", "graphqlConfig", "minCharsToSearch", "onFocus", "waitUntilFocused", "defaultToOnlyOption", "shouldSearch"]);

  var _useFormikContext = useFormikContext(),
      setFieldValue = _useFormikContext.setFieldValue;

  var _cacheUniq = cacheUniq;
  var selectRef = useRef();

  var _useState = useState([]),
      previousOptions = _useState[0],
      setPreviousOptions = _useState[1];

  var _useState2 = useState(0),
      numTimesResourceCalled = _useState2[0],
      setNumTimesResourceCalled = _useState2[1];

  if (_cacheUniq === undefined && watchParams) {
    var params = _objectSpread({
      customerId: rest.customerId
    }, rest.parameters);

    _cacheUniq = watchParams.map(function (watchParam) {
      return params[watchParam];
    }).join(',');
  }

  useEffect(function () {
    setNumTimesResourceCalled(0);
  }, [_cacheUniq]);

  var onFocusHandler = function onFocusHandler() {
    if (onFocus) onFocus.apply(void 0, arguments);
  };

  var loadOptions = function loadOptions() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var inputValue = args[0],
        _args$ = args[2],
        additional = _args$ === void 0 ? {} : _args$;
    var page = additional.page;
    var shouldReturnPreviousOptions = inputValue.length > 0 && minCharsToSearch !== undefined && inputValue.length < minCharsToSearch;

    if (shouldReturnPreviousOptions) {
      return {
        options: previousOptions,
        hasMore: false,
        additional: {
          page: page,
          limit: itemsPerPage
        }
      };
    }

    var data;
    var params;

    if (graphqlConfig) {
      data = {
        variables: {
          perPage: itemsPerPage,
          filters: {
            q: encodeURIComponent(inputValue)
          }
        }
      };

      if (args.length !== 3) {
        if (typeof rest.parameters === 'function') {
          data = rest.parameters(data);
        } else {
          data = _objectSpread({}, data, {}, rest.parameters);
        }
      }

      if (graphqlConfig.query) {
        data.query = graphqlConfig.query;
      }
    } else {
      params = {
        q: encodeURIComponent(inputValue),
        limit: itemsPerPage,
        customerId: rest.customerId
      };

      if (args.length !== 3) {
        if (typeof rest.parameters === 'function') {
          params = rest.parameters(params);
        } else {
          params = _objectSpread({}, params, {}, rest.parameters);
        }
      }
    }

    if (args.length === 3) {
      if (graphqlConfig) {
        data.variables.page = page;

        if (typeof rest.parameters === 'function') {
          data = rest.parameters(data);
        }
      } else {
        params.offset = (page - 1) * itemsPerPage;

        if (typeof rest.parameters === 'function') {
          params = rest.parameters(params);
        } else {
          params = _objectSpread({}, params, {}, rest.parameters);
        }
      }
    } else {
      page = 1;
    }

    var requiredSatisfied = !rest.requiredParams || rest.requiredParams.length === 0;

    if (!requiredSatisfied) {
      if (graphqlConfig) {
        requiredSatisfied = rest.requiredParams.every(function (param) {
          return get(data, "variables.filters." + param);
        });
      } else {
        requiredSatisfied = rest.requiredParams.every(function (param) {
          return params[param];
        });
      }
    }

    var _shouldSearch = shouldSearch;

    if (typeof shouldSearch === 'function') {
      _shouldSearch = shouldSearch.apply(void 0, args);
    }

    if (rest.isDisabled || !requiredSatisfied || !_shouldSearch) {
      return {
        options: [],
        hasMore: false
      };
    }

    if (onPageChange) onPageChange(inputValue, page);
    var fetch;

    if (graphqlConfig || method === 'POST') {
      fetch = function fetch() {
        return resource.post(data || params, _objectSpread({
          headers: {
            'Content-Type': 'application/json'
          }
        }, rest.requestConfig));
      };
    } else {
      fetch = function fetch() {
        return resource.postGet(qs.stringify(params, {
          encode: false,
          arrayFormat: 'repeat',
          indices: false,
          allowDots: true
        }), _objectSpread({
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }, rest.requestConfig));
      };
    }

    return fetch().then(function _callee(resp) {
      var getResult, items;
      return _regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!resp || !resp.data)) {
                _context.next = 2;
                break;
              }

              throw new Error("API returned an invalid response.");

            case 2:
              getResult = rest.getResult || resource.getResult;
              items = typeof getResult === 'function' ? getResult.call(resource, resp.data) : resp.data[getResult];

              if (hasMore === undefined) {
                if (graphqlConfig) {
                  hasMore = function hasMore(data) {
                    return get(data.data, graphqlConfig.type + "Pagination.pageInfo.hasNextPage", false);
                  };
                } else {
                  hasMore = function hasMore(_ref2) {
                    var totalCount = _ref2.totalCount,
                        limit = _ref2.limit,
                        offset = _ref2.offset;
                    return totalCount > offset + limit;
                  };
                }
              }

              hasMore = typeof hasMore === 'function' ? hasMore(resp.data) : hasMore;

              if (Array.isArray(items)) {
                _context.next = 8;
                break;
              }

              throw new TypeError("Expected data to be an array but got `" + typeof items + "`. Use the `getData` prop to specify how to get the data from the API response.");

            case 8:
              setPreviousOptions(items);
              /*
               * We only want to default to the first option under the following conditions:
               * 1. defaultToOnlyOption is true
               * 2. There is only one option
               * 3. waitUntilFocused is false - Otherwise we would be defaulting the value when the user has the dropdown open to select a value
               * 4. numTimesResourceCalled is 0 - This means this is the first time calling the resource. Again, otherwise we would be defaulting the value when the user has the dropdown open to select a value - keeping in mind numTimesResourceCalled resets to 0 any time cacheUniq changes
               */

              if (!(defaultToOnlyOption && items.length === 1 && !waitUntilFocused && numTimesResourceCalled === 0)) {
                _context.next = 12;
                break;
              }

              _context.next = 12;
              return _regeneratorRuntime.awrap(setFieldValue(name, items[0]));

            case 12:
              setNumTimesResourceCalled(numTimesResourceCalled + 1);
              return _context.abrupt("return", {
                options: items,
                hasMore: hasMore,
                additional: _objectSpread({}, additional, {
                  page: page + 1
                })
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      });
    })["catch"](function () {
      return {
        options: [],
        hasMore: false
      };
    });
  };

  var Tag = rest.label ? SelectField : Select;
  return React.createElement(Tag, Object.assign({
    name: name,
    selectRef: selectRef,
    loadOptions: loadOptions,
    defaultOptions: waitUntilFocused ? [] : true,
    pagination: true,
    raw: true,
    debounceTimeout: debounceTimeout,
    cacheUniq: _cacheUniq,
    additional: _objectSpread({
      page: 1
    }, additional)
  }, rest, {
    onFocus: onFocusHandler
  }));
};

ResourceSelect.defaultProps = {
  delay: 350,
  itemsPerPage: 50,
  waitUntilFocused: false,
  defaultToOnlyOption: false,
  shouldSearch: true
};

var ucFirst = function ucFirst(str) {
  return str && str.charAt(0).toUpperCase() + str.slice(1);
};

ResourceSelect.create = function (defaults) {
  var SpecificResourceSelect = function SpecificResourceSelect(props) {
    return React.createElement(ResourceSelect, Object.assign({}, defaults, props));
  };

  SpecificResourceSelect.displayName = ucFirst(defaults.resource.defaultConfig.name) + "Select";
  return SpecificResourceSelect;
};

export default ResourceSelect;